module.exports = __webpack_public_path__ + "img/mhtit3.313d1c41.png";